import React from 'react'

const DataDeletionSteps = () => {
  return (
    <div>
       <h4>STEPS TO TAKE FOR REQUESTING YOUR DATA DELETION</h4>
        <p>Step -1 Login into your app</p>
        <p>Step -2 Copy your Admission Number</p>
        <p>Step -3 Open gmail and mail to gouthamp0306@gmail.com For account DATA deletion by pasting your Admission number</p>
    </div>
  )
}

export default DataDeletionSteps